import { render, staticRenderFns } from "./OnlinePayment.vue?vue&type=template&id=48084f15&scoped=true"
import script from "./OnlinePayment.vue?vue&type=script&lang=js"
export * from "./OnlinePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48084f15",
  null
  
)

export default component.exports